import { ISalesforceInfo } from "@app/support/support.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const salesforceContactAdapter: EntityAdapter<ISalesforceInfo> = createEntityAdapter<ISalesforceInfo>({
	selectId: info => info.c4UserId
});